import * as React from 'react'
import {Component, ReactElement, ReactNode, RefObject} from 'react'
import styled from 'styled-components'
import {Colors} from '../../../../styledComponents/Constants'
import {Box, Drawer, Popover} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {UnstyledLinkStyledButton} from '../../../../styledComponents/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEllipsisH, faPen, faTrash} from '@fortawesome/free-solid-svg-icons'
import {HideInPC, HideInSP} from '../../../../styledComponents/ResponsiveConvenience'
import {Nullable} from '../../../../app/TypeHelpers'
import {LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {DisplayItemDivider} from '../../../../styledComponents/DisplayItem'
import {IconProp} from '@fortawesome/fontawesome-svg-core'

interface Props {
    id: string
    label: string
    isEditable: boolean
    isDeletable: boolean
    onEdit: () => void
    onDelete: () => void
    onMenu?: () => void
}

interface State {
    isOpenMenu: boolean
}

export default class NatDisasterActionMenu extends Component<Props, State> {
    menuButtonRef: RefObject<HTMLButtonElement>

    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            isOpenMenu: false
        }
        this.menuButtonRef = React.createRef()
    }

    handleClickCommentMenuButton = (): void => {
        this.setState({isOpenMenu: true})
        if (this.props.onMenu) {
            this.props.onMenu()
        }
    }

    handleCloseMenu = (): void => {
        this.setState({isOpenMenu: false})
    }

    handleEditTopic = (): void => {
        this.handleCloseMenu()
        this.props.onEdit()
    }

    handleDeleteTopic = (): void => {
        this.handleCloseMenu()
        this.props.onDelete()
    }

    renderMenu(icon: IconProp, label: string, handleMenuClick: () => void): ReactNode {
        return <StyledButton onClick={handleMenuClick}>
            <LeftRowFlexContainer>
                <FontAwesomeIcon icon={icon}/>
                <Box width={'15px'}/>
                {label}
            </LeftRowFlexContainer>
        </StyledButton>
    }

    render(): Nullable<ReactElement> {
        const {label, isEditable, isDeletable} = this.props

        if (!isEditable && !isDeletable) {
            return null
        }

        const menuNodeList: ReactNode[] = []
        if (isEditable) {
            menuNodeList.push(this.renderMenu(faPen, `${label}を編集`, this.handleEditTopic))
        }
        if (isDeletable) {
            menuNodeList.push(this.renderMenu(faTrash, `${label}を削除`, this.handleDeleteTopic))
        }
        const menuNode = menuNodeList.map((node, index) => {
            return <React.Fragment key={index}>
                {index > 0 && <DisplayItemDivider/>}
                {node}
            </React.Fragment>
        })

        return (
            <>
                <UnstyledLinkStyledButton
                    id={this.props.id}
                    onClick={this.handleClickCommentMenuButton}
                    ref={this.menuButtonRef}
                >
                    <FontAwesomeIcon icon={faEllipsisH} color={Colors.AccentDark}/>
                </UnstyledLinkStyledButton>
                <HideInSP>
                    <CommentMenuPopover
                        open={this.state.isOpenMenu}
                        onClose={this.handleCloseMenu}
                        anchorEl={this.menuButtonRef.current}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                        transformOrigin={{vertical: 'top', horizontal: 'center'}}
                    >
                        {menuNode}
                    </CommentMenuPopover>
                </HideInSP>
                <HideInPC>
                    <CommentMenuDrawer
                        anchor={'bottom'}
                        open={this.state.isOpenMenu}
                        onClose={this.handleCloseMenu}
                    >
                        {menuNode}
                    </CommentMenuDrawer>
                </HideInPC>
            </>
        )
    }
}

const CommentMenuPopover = withStyles({
    paper: {
        width: '245px',
        border: `1px solid ${Colors.Background}`,
        borderRadius: '10px'
    }
})(Popover)

const CommentMenuDrawer = withStyles({
    paper: {
        border: `1px solid ${Colors.Background}`,
        borderRadius: '10px 10px 0 0',
        maxHeight: '125px',
        height: 'auto'
    }
})(Drawer)

const StyledButton = styled(UnstyledLinkStyledButton)`
    padding: 20px 20px 20px 15px;
    line-height: 24px;
`